import useFastCheckoutLoading from './useFastCheckoutLoading';

export default useFastCheckoutLoading;
